import { Page401, Page404, Page498, useStoreUIV2 } from '@gimlite/ui-v2';
import { observer } from 'mobx-react-lite';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from 'react-router-dom';
import MainUse from './main';
import { EquipmentPage } from './pages/equipment/view/equipment.page';

export const CustomRouter = observer(() => {
  const { SSOStore } = useStoreUIV2();

  const sitemap = [
    {
      path: '/',
      element: <MainUse />,
      children: [
        {
          index: true,
          element: <Navigate to={`/board`} replace />,
        },
        {
          path: '/board',
          element: <EquipmentPage />,
        },
      ],
    },
    {
      path: '*',
      element: <Page404 />,
    },
  ];

  return SSOStore?.error === 'UNAUTHORIZED' ? (
    <Page401 />
  ) : SSOStore.authenticated && SSOStore.user ? (
    <RouterProvider router={createBrowserRouter(sitemap)}></RouterProvider>
  ) : (
    <Page498 />
  );
});
